import type { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http'
import { HttpEventType } from '@angular/common/http'
import { inject } from '@angular/core'
import type { Observable } from 'rxjs'
import { tap } from 'rxjs/operators'

import { SiteStore } from '@app/store/site.store'

export const openReplayInterceptor = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const siteStore = inject(SiteStore)

  if (!siteStore.features().usr_log_requests) {
    return next(request)
  }

  return next(request).pipe(
    tap(event => {
      if (window.OpenReplay && event.type === HttpEventType.Response) {
        window.OpenReplay.event(`${request.url} [request]`, {
          method: request.method,
          url: request.url,
          params: request.params,
        })
        window.OpenReplay.event(`${request.url} [response]`, {
          body: event.body,
          status: event.status,
          headers: event.headers,
        })
      }
    }),
  )
}
